import { render, staticRenderFns } from "./ListaProdutos.vue?vue&type=template&id=c26354ae&scoped=true"
import script from "./ListaProdutos.vue?vue&type=script&lang=js"
export * from "./ListaProdutos.vue?vue&type=script&lang=js"
import style0 from "./ListaProdutos.vue?vue&type=style&index=0&id=c26354ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26354ae",
  null
  
)

export default component.exports